export /* istanbul ignore next: boilerplate code */ default function isDemo() {
  return process.env.DEMO;
}
